import React, { useEffect, useRef, useState } from 'react'

import { motion } from 'framer-motion'
import styles from './styles'
import injectSheet from 'react-jss'
import compose from 'recompose/compose'

const Toast = props => {
    const { position, text, visible, id, classes } = props
    const toastRef = useRef()

    const [toastPosition, setToastPosition] = useState(0)
    useEffect(() => {
        if (toastRef.current && id) {
            setToastPosition(0)
        }
    }, [id])

    return (
        <>
            {visible && (
                <motion.button
                    initial={{ y: 100, x: '-50%' }}
                    animate={{ y: toastPosition, x: '-50%' }}
                    transition={{
                        ease: toastPosition === 0 ? [0.28, 0.57, 0.2, 1] : 'easeIn',
                        duration: toastPosition === 0 ? 0.5 : 0.35,
                        onComplete: () => {
                            setTimeout(() => {
                                setToastPosition(100)
                            }, 1500)
                        },
                    }}
                    type="button"
                    ref={toastRef}
                    className={`toast-test ${classes.toast} ${classes[position]}`}
                    data-testid="toast-container"
                >
                    <span className={classes.text}>{text}</span>
                </motion.button>
            )}
        </>
    )
}

Toast.defaultProps = {
    onComplete: () => {},
    position: 'bottom',
    visible: false,
    duration: 5,
}

export default compose(injectSheet(styles))(Toast)
